"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * This middleware is used to store the shared payload of the Page event.
 * The shared payload is used to send `Web Vitals Captured` track event.
 * It is used due to limitation of Segment analytics.js library. It is not able to send an event generated during unloading of a page.
 */

const {
  commonEventProperties
} = require('../constants');
let pageSharedPayload = undefined;
const storePageSharedPayloadMiddleware = _ref => {
  let {
    payload,
    next
  } = _ref;
  try {
    if (payload.obj?.type === 'page') {
      const {
        integrations,
        userId,
        anonymousId,
        context
      } = payload.obj;
      const commonProperties = getCommonProperties(payload.obj?.properties);
      pageSharedPayload = {
        integrations,
        userId,
        anonymousId,
        context,
        properties: commonProperties
      };
    }
  } finally {
    next(payload);
  }
};
const getCommonProperties = properties => {
  if (!properties) {
    return {};
  }
  const commonProperties = {};
  commonEventProperties.forEach(commonPropertyName => {
    const propertyValue = properties[commonPropertyName];
    if (typeof propertyValue === 'string') {
      commonProperties[commonPropertyName] = propertyValue;
    }
  });
  return commonProperties;
};
const getMiddlewareDefinitions = () => {
  return [storePageSharedPayloadMiddleware];
};
const getPageSharedPayload = () => {
  if (!pageSharedPayload) {
    return undefined;
  }
  return _objectSpread({}, pageSharedPayload);
};
const init = () => {
  pageSharedPayload = undefined;
};
module.exports = {
  getPageSharedPayload,
  getSourceMiddlewares: getMiddlewareDefinitions,
  init
};